export const getBrowserInfo = () => {
  const ua = navigator.userAgent

  const patterns = [
    { name: 'Edge', regex: /Edg\/(\d+)/ },
    { name: 'Opera', regex: /OPR\/(\d+)/ },
    { name: 'Chrome', regex: /Chrome\/(\d+)/ },
    { name: 'Firefox', regex: /Firefox\/(\d+)/ },
    { name: 'Safari', regex: /Version\/(\d+).*Safari/ },
  ]

  for (const { name, regex } of patterns) {
    const match = ua.match(regex)
    if (match) {
      return { name, version: match[1] }
    }
  }

  return { name: 'Unknown', version: 'Unknown' }
}
